<template>
  <VCombobox
    v-model="select"
    :label="label"
    :prepend-inner-icon="icon"
    :loading="queryStatus"
    :items="items"
    :search-input.sync="search"
    :menu-props="{ closeOnContentClick: true }"
    class="mx-3"
    flat
    deletable-chips
    chips
    :multiple="multiple"
    @change="onItemsChange"
  />
</template>

<script>
import { NetworkStatus } from 'apollo-client/core/networkStatus'
import _ from 'lodash'
export default {
  name: 'AsyncAutoComplete',
  props: {
    icon: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Label'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    defaultArraySelect: {
      type: Array,
      default: function () {
        return []
      }
    },
    defaultSelect: {
      type: String,
      default: ''
    },
    getGqlQuery: {
      type: Object,
      default: function () {
        return null
      }
    },
    getQueryVariables: {
      type: Function,
      default: function () {
        return {}
      }
    },
    updateContextVariable: {
      type: Function,
      default: function (key, value) {
        if (this.hasOwnProperty(key)) {
          this[key] = value
        }
      }
    },
    defaultItems: {
      type: Array,
      default: function () {
        return []
      }
    },
    parseData: {
      type: Function,
      default: function (data) {}
    },
    setQueryStatus: {
      type: Function,
      default: function (val) {}
    },
    getQueryStatus: {
      type: Function,
      default: function () {}
    },
    setStatusMessage: {
      type: Function,
      default: function (val) {}
    },
    getStatusMessage: {
      type: Function,
      default: function () {}
    },
    clearAll: {
      type: Function,
      default: function () {}
    }
  },
  data () {
    return {
      search: null,
      select: this.multiple ? this.defaultArraySelect : this.defaultSelect,
      items: this.defaultItems
    }
  },
  computed: {
    queryStatus: {
      get: function () {
        return this.getQueryStatus()
      },
      set: function (val) {
        this.setQueryStatus(val)
      }
    }
  },
  apollo: {
    getTableItems: {
      query () {
        return this.getGqlQuery
      },
      variables () {
        return this.getQueryVariables()
      },
      manual: true,
      result ({ data, loading, networkStatus }) {
        // console.log('run GQL')
        this.setNetworkStatus(networkStatus)
        if (!loading && networkStatus !== NetworkStatus.error) {
          this.parseData(data)
        }
      },
      error (error) {
        this.queryStatus = false
        this.$store.dispatch('alert/error', error.message)
      }
    }
  },
  watch: {
    search () {
      this.debouncedGetQuerySelect()
    },
    defaultArraySelect (val) {
      if (this.multiple) this.select = val
    },
    defaultSelect (val) {
      if (!this.multiple) this.select = val
    },
    defaultItems (val) {
      this.items = val
    }
  },
  created: function () {
    this.debouncedGetQuerySelect = _.debounce(this.querySelect, 300)
  },
  beforeDestroy () {
    this.clearAll()
  },
  methods: {
    querySelect () {
      if (!this.search) {
        this.updateContextVariable('name', '')
      } else {
        this.updateContextVariable('name', this.search)
      }
    },
    onItemsChange (value) {
      this.search = null
      this.$emit('itemsChange', value)
    },
    setNetworkStatus (networkStatus) {
      switch (networkStatus) {
        case NetworkStatus.loading:
          this.queryStatus = true
          // this.statusMessage = 'Loading contacts. Please wait...'
          break
        case NetworkStatus.setVariables:
          this.queryStatus = true
          // this.statusMessage = 'Loading contacts. Please wait...'
          break
        case NetworkStatus.ready:
          break
        case NetworkStatus.poll:
          break
        case NetworkStatus.error:
          this.queryStatus = false
          break
        default:
          break
      }
    }
  }
}
</script>

<style scoped>

</style>
